import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartBaseFieldPack: FieldPack = {
  id: 'orgchart-base',
  name: 'Core Identity',
  description: 'Core person fields required for all planning workflows',
  version: '1.0.0',
  fields: [
    {
      id: 'name',
      label: 'Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 100,
      required: true,
      maxLength: 200,
      sensitivity: 'public',
    },
    {
      id: 'firstName',
      label: 'First Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 99,
      maxLength: 100,
      sensitivity: 'public',
    },
    {
      id: 'lastName',
      label: 'Last Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 98,
      maxLength: 100,
      sensitivity: 'public',
    },
    {
      id: 'preferredName',
      label: 'Preferred Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 97,
      maxLength: 100,
      sensitivity: 'public',
    },
    {
      id: 'title',
      label: 'Job Title',
      type: FieldType.TEXT,
      tags: ['identity', 'role'],
      priority: 95,
      maxLength: 200,
      sensitivity: 'public',
    },
    {
      id: 'email',
      label: 'Email',
      type: FieldType.TEXT,
      tags: ['identity', 'contact'],
      priority: 90,
      maxLength: 320,
      sensitivity: 'internal',
    },
    {
      id: 'phone',
      label: 'Phone',
      type: FieldType.TEXT,
      tags: ['contact'],
      priority: 40,
      sensitivity: 'internal',
    },
    {
      id: 'personId',
      label: 'Employee ID',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'department',
      label: 'Department',
      // Options are derived from the chart's existing departments at render
      // time (see derivedFieldOptions.ts); custom entry covers a new one.
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['identity', 'organization'],
      priority: 80,
      sensitivity: 'public',
    },
    {
      id: 'reportsTo',
      label: 'Reports To',
      type: FieldType.TEXT,
      tags: ['identity', 'organization'],
      priority: 75,
      sensitivity: 'public',
    },
    {
      id: 'photoRef',
      label: 'Photo',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 70,
      sensitivity: 'public',
    },
    {
      id: 'joinDate',
      label: 'Join Date',
      type: FieldType.DATE,
      tags: ['identity', 'timeline'],
      priority: 65,
      sensitivity: 'internal',
    },
    {
      id: 'departureDate',
      label: 'Employment End Date',
      type: FieldType.DATE,
      tags: ['identity', 'timeline'],
      priority: 60,
      sensitivity: 'internal',
    },
    {
      id: 'employeeNumber',
      label: 'Employee Number',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 55,
      sensitivity: 'internal',
    },
    {
      id: 'status',
      label: 'Employment Status',
      type: FieldType.SELECT,
      tags: ['identity', 'employment'],
      priority: 50,
      sensitivity: 'internal',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'on_leave', label: 'On Leave' },
        { value: 'terminated', label: 'Terminated' },
      ],
    },
    {
      id: 'notes',
      label: 'Notes',
      type: FieldType.TEXT,
      tags: ['notes'],
      priority: 10,
      multiline: true,
      sensitivity: 'internal',
    },
  ],
};
